export default function mediaItemFeed() {
  return {
    _id: false,
    type: 'droplet.mediaItemFeed',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    sort: 'newest',
    sortKey: 'released.date',
    filters: [],
    match: 'all',
    itemCount: 3,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/media-item-feed/droplet.schema.js